import { HttpInstance } from "lib/HttpLib";

// ==================== GET ====================
// [GET] 권한별 메뉴 표시
export async function getAuthData() {
  return await HttpInstance.get(process.env.REACT_APP_AUTH_SERVER + "/global/perm_auth", {});
}
